module.exports = __webpack_public_path__ + "static/media/rider-location.46c28d6a.svg";